import React, { useState, useEffect, useLayoutEffect } from 'react';
import uniqid from 'uniqid';

import { Stack } from 'ui/stack';
import { Box } from 'ui/box';

import { Typography } from 'ui/typography';
import { Loader } from 'ui/loader';
import Breadcrumbs from 'components/partials/beadcrumbs/breadcrumbs';
// import WasResourseHelpfulBanner from 'containers/user/learn/components/was-resource-helpful/was-resource-helpful';
import RelatedContent from 'containers/user/learn/components/related-content/related-content';
import PageNav from 'containers/user/learn/components/page-nav/page-nav';

import api from 'api';

import { useCurrentUser } from 'hooks/api/use-current-user';

import { getBlocksFromContent } from 'containers/user/learn/heplers/get-blocks-from-content';
import {
  getIsRelatedContentShown,
  getRelatedContent,
} from 'containers/user/learn/heplers/content-builder-helpers';
import { onResize } from 'helpers/resize';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

interface GuideData {
  name?: string;
  content?: Array<{
    id: string | number;
    type: string;
    [key: string]: unknown;
  }>;
  [key: string]: unknown;
}

interface GuideProps {
  guideId: string | number;
}

const Guide = ({ guideId }: GuideProps): React.JSX.Element => {
  const [guide, setGuide] = useState<GuideData>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [isTabletView, setIsTabletView] = useState<boolean>(false);

  const user = useCurrentUser();

  useEffect(() => {
    setLoading(true);
    api
      .getGuide(guideId, user?.data?.oktaUserId ?? '')
      .then((res) => {
        setGuide(
          (res as { data: { data: { attributes: GuideData } } }).data.data
            .attributes
        );
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useLayoutEffect(() => {
    onResize(setIsTabletView);
  }, []);

  return loading ? (
    <Loader {...{ loading }} />
  ) : (
    <ResponsiveWrapper customClass="flex flex-col">
      <Breadcrumbs
        breadcrumbs={[
          { label: 'Learn', href: '/learn' },
          { label: 'Guides', href: '/learn/content/guides' },
        ]}
        customClass="!mt-5"
      />
      <Typography
        data-testid="guide-heading"
        variant="h1"
        sx={{ pt: { mobile: 2, xs: 3 }, pb: { mobile: 3, xs: 6 } }}
      >
        {guide.name}
      </Typography>
      {isTabletView && (
        <PageNav
          content={guide.content}
          isTabletView={true}
          navTitle="In this guide"
        />
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          order: 1,
          '@media (min-width: 375px)': { flexDirection: 'column' },
          '@media (min-width: 1280px)': { flexDirection: 'row' },
        }}
      >
        <ResponsiveWrapper customClass="flex flex-col">
          {guide.content?.map((component) =>
            getBlocksFromContent({ ...component, key: uniqid() })
          )}
          {/* <WasResourseHelpfulBanner relatedTags={guide.relatedTags} /> */}
          {getIsRelatedContentShown(guide as never, 'guideIsLinkedTo') && (
            <RelatedContent
              content={
                getRelatedContent(guide as never, 'guideIsLinkedTo') as never
              }
            />
          )}
        </ResponsiveWrapper>
        <Stack>
          {!isTabletView && (
            <PageNav content={guide.content} navTitle="In this guide" />
          )}
        </Stack>
      </Box>
    </ResponsiveWrapper>
  );
};

export default Guide;
